import(/* webpackMode: "eager" */ "/app/apps/ats-recruiter/app/error.tsx");
